import {
  OreInput,
  OreMessageBar,
  OreStack,
  OreSwitch,
  OreText,
} from '@edenredespana/oreneta'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { PasswordRecoveryData } from '@/Account/ui/hooks'
import { handleErrors } from '@/Shared/ui/form'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

interface PasswordRecoveryBasicFormProps {
  isBlocked: boolean
  errorMessage: string
}

export const PasswordRecoveryBasicForm = ({
  isBlocked,
  errorMessage,
}: PasswordRecoveryBasicFormProps): JSX.Element => {
  const { t } = useTranslation()
  const { register, formState } = useFormContext<PasswordRecoveryData>()
  const { errors } = handleErrors(formState)

  return (
    <OreStack direction="column" space="small" placeContent="stretch">
      <OreInput
        {...register('email')}
        {...errors('email')}
        id="email"
        label={t(formTranslation.common.identifier.email.label)}
        labelTooltip={t(formTranslation.common.identifier.email.tooltip)}
        startAdornment="@"
        placeholder={t(formTranslation.common.identifier.email.placeholder)}
        legend={t(formTranslation.common.identifier.email.legend)}
        required
        disabled={isBlocked}
        maxLength={75}
      />
      <OreInput
        {...register('merchantId')}
        {...errors('merchantId')}
        id="merchantId"
        label={t(formTranslation.common.identifier.merchantId.label)}
        labelTooltip={t(formTranslation.common.identifier.merchantId.tooltip)}
        placeholder={t(formTranslation.common.identifier.merchantId.placeholder)}
        required
        disabled={isBlocked}
        minLength={4}
      />
      <OreInput
        {...register('legalId')}
        {...errors('legalId')}
        id="legalId"
        label={t(formTranslation.common.identifier.legalId.label)}
        placeholder={t(formTranslation.common.identifier.legalId.placeholder)}
        legend={t(formTranslation.common.identifier.legalId.legend)}
        required
        disabled={isBlocked}
        maxLength={15}
      />
      <OreText tone="neutral">{t(formTranslation.common.requiredFields)}</OreText>

      {isBlocked && <OreMessageBar>{errorMessage}</OreMessageBar>}
    </OreStack>
  )
}
